import { useQuery } from "@apollo/client";

import { GqlSettingsFormTemplateMasterFormType } from "~/__generated__";

import { SettingsMasterFormRoute_GetByTypeDocument } from "../../../queries.generated";

export default function useSettingsMasterFormRoute_GetByType(type: GqlSettingsFormTemplateMasterFormType) {
    const { data, loading, error } = useQuery(SettingsMasterFormRoute_GetByTypeDocument, {
        variables: { type },
    });

    return {
        masterForm: data,
        loading,
        error,
    };
}
